import { defineMessages } from 'react-intl';


const messages = defineMessages({
  title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  description: {
    id: 'Description',
    defaultMessage: 'Description',
  },
  link: {
    id: 'Link',
    defaultMessage: 'Link',
  },
  links: {
    id: 'Links',
    defaultMessage: 'Links',
  },
  addLink: {
    id: 'addLink',
    defaultMessage: 'Add Link',
  },
});

const linkSchema = (props) => ({
  title: props.intl.formatMessage(messages.link),
  addMessage: props.intl.formatMessage(messages.addLink),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['title', 'url'],
    },
  ],
  properties: {
    title: {
      title: props.intl.formatMessage(messages.title),
      widget: 'text',
    },
    url: {
      title: props.intl.formatMessage(messages.link),
      widget: 'object_browser',
      mode: 'link',
      allowExternals: true,
    },
  },
  required: ['title', 'url'],
});


export const schema = (props) => {
  return {
    required: [],
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['title', 'description', 'links'],
      },
    ],
    properties: {
      title: {
        title: props.intl.formatMessage(messages.title),
        widget: 'text',
      },
      description: {
        title: props.intl.formatMessage(messages.description),
        widget: 'text',
      },
      links: {
        title: props.intl.formatMessage(messages.links),
        description: props.intl.formatMessage(messages.addLink),
        schema: linkSchema(props),
        widget: 'object_list',
      },
    },
  };
};

export default schema;